import { Registry } from '@react-registry'

export const superscriptDeserializer = () => {
  return {
    superscript: true,
  }
}

Registry.register(superscriptDeserializer, { id: 'SUP', registry: 'inline-deserializer' })
